import { atom } from 'jotai';

import type {
  ZuubPatientData,
  ZuubPatientDetailedData,
} from '../../@types/zuub/contracts';
import type { Appointment } from '../../react-query/useAppointments';

export const insuranceStatusFilterAtom = atom<string>('all');

// Atom to store the selected card filter (all, pending, failed, verified)
export const selectedCardAtom = atom<'all' | 'pending' | 'failed' | 'verified'>(
  'all',
);

// Atom to store the selected patient's Zuub data for the benefits page
export const selectedPatientZuubDataAtom = atom<ZuubPatientData | null>(null);

// Atom to store the currently selected plan based on dropdown selections
export const selectedPlanAtom = atom<ZuubPatientDetailedData | null>(null);

// Atom to store the selected patient's appointment data for last treatments history
export const selectedPatientAppointmentAtom = atom<Appointment | null>(null);
